<template>
    <div class="boleto-payment-form">
        <form @submit.prevent="submit($event)" id="boleto-form" class="row m-0 p-0">
            <div class="col-md-8 px-0">
                <div class="alert alert-info mb-0 p-2">
                    Receba mensalmente uma fatura e escolha como pagar: PIX, cartão ou boleto.
                </div>
            </div>
            <div class="col-md-2 col-6 mt-md-0 mt-2 px-0 ps-md-2 pe-2 d-flex align-items-center">
                <button v-if="!loading" class="form-control btn btn-dark" type="button" @click="cancel"> Voltar </button>
            </div>
            <div v-if="!loading" class="col-md-2 col-6 mt-md-0 mt-2 px-0 ps-2 d-flex align-items-center">
                <button class="form-control btn btn-primary text-light" type="submit"> Pagar </button>
            </div>
            <div v-else class="col-md-2 col-12 mt-md-0 mt-2 px-0 ps-md-2 d-flex align-items-center">
                <button class="form-control btn btn-primary d-flex justify-content-center align-items-center" type="button" disabled>
                    <div style="width: 1.3rem; height: 1.3rem;" class="spinner-border text-light" role="status"></div>
                    <div class="sr-only">Carregando</div>
                </button>
            </div>
        </form>
        <div v-if="fee" class="alert alert-info mb-2">
            <i class="fas fa-info me-2"></i> 
            Acréscimo de {{ fee.valor_parametro | currency }} em cada parcela, referente a taxa de serviços de emissão e compensação.
        </div>
    </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
    data() {
        return {
            selected: 1
        }
    },
    props: {
        cart: {
            required: true,
            type: Object,
        },
        installments: {
            required: true,
            type: Array,
        },
        products: {
            required: true,
            type: Array,
        },
        loading: {
            default: false,
            type: Boolean
        },
        rules: {
            type: Array,
        }
    },
    methods: {
        async submit($event) {
            $event.preventDefault()
            $event.stopPropagation()

            try {
                this.loading = true
                
                const token = await window.generateRecaptchaToken();
                
                const response = await axios.post('/api/payment/sign', {
                    cart: this.cart,
                    type: 'fatura-mensal',
                    products: this.products,
                    token: token,
                });
                
                this.$emit('submit', response.data.order)
            } catch (error) {
                console.log(error)
                this.$emit('error', error.response.data.message)
            }
        },
        cancel() {
            this.$emit('close')
        },
        format(value) {
            const formatter = new Intl.NumberFormat(
                window.i18n.locale.replace('_', '-'), 
                { 
                    style: 'currency', 
                    currency: window.i18n.currency 
                }
            )
            return formatter.format(value)
        }
    },
    computed: {
        fee() {
            const rules = this.rules.filter((i) => i.nome == 'taxa_bol_socio')

            if (!rules) return false

            return rules[0]
        }
    }
})
</script>
